import { isEqual, map, uniq } from 'lodash'
import { parse, stringify } from 'query-string'
import React, { Component, createContext } from 'react'
import { isMobile } from 'react-device-detect'
import { connect } from 'react-redux'
import reactStringReplace from 'react-string-replace'
import { Tooltip } from 'react-tippy'
import { createStructuredSelector } from 'reselect'

import { setZendeskLocation } from 'utils/locations'
import { EVENTS, trackEvent } from 'utils/tracking/events-tracker'
import { isThreeDSecureError } from 'utils/three-d-secure-helper/is-three-d-secure-error'
import { UpdatePaymentMethodModal } from 'components/modal/update-payment-method-modal'
import { trackMonthlyExperiment } from 'utils/monthly-experiment'

import Icon from '../../components/icon/Icon'
import Loading from '../../components/loading/Loading'
import AdblockDetectModal from '../../components/modal/AdblockDetectModal'
import AIWPlanModal from '../../components/modal/AIWPlanModal'
import ATPCrossSellModal from '../../components/modal/ATPCrossSellModal'
import CheckoutModal from '../../components/modal/checkoutModal/index'
import ConfirmationModal from '../../components/modal/ConfirmationModal'
import EmailConfirmModal from '../../components/modal/EmailConfirmModal'
import ErrorModal from '../../components/modal/ErrorModal'
import ExitIntentModal from '../../components/modal/ExitIntentModal'
import IntentExitModal from '../../components/modal/IntentExitModal'
import LoginLimitModal from '../../components/modal/LoginLimitModal'
import NavigationChangeModal from '../../components/modal/NavigationChangeNotificationModal'
import PastDueModal from '../../components/modal/PastDueModal'
import PaymentErrorModal from '../../components/modal/PaymentErrorModal'
import ProjectSettingsModal from '../../components/modal/ProjectSettingsModal'
import PromptModal from '../../components/modal/PromptModal'
import SpecialLifetimeModal from '../../components/modal/SpecialLifetimeModal'
import {
  TableNotification,
  TableNotificationBar,
} from '../../components/tables/styled'
import {
  getLanguageCode,
  pushWithLanguageRoutes,
  translate,
} from '../../utils/translation'
import { recaptchaTokenValut, ReCAPTCHAWrapper } from '../../utils/recaptcha'
import {
  allowPromptModal,
  openInNewTab,
  sanitizeDomain,
  sendMessage,
} from '../../utils/functions'
import {
  purchaseAddons,
  updateUserPaymentMethod,
  resendVerificationEmail,
} from '../../utils/api'
import {
  isPaidUser,
  shouldBlockPastDue,
  BlockFeatureAction,
  SIDEBAR,
  isFreeTrialUsed,
  isFreeTrialUser,
} from '../../utils/freeVersionBlock'
import { fonts, palette } from '../../styles/variables'
import { Desktop, Mobile } from '../../utils/media'
import {
  KISSMETRICS_TRACK_EVENTS,
  kissmetricsRecordingEvent,
  PROPERTY_NAMES,
  PROPERTY_VALUES,
} from '../../utils/kissmetrics'
import { Text } from '../../components/topography/index'
import { TurnstileProvider } from '../../components/turnstile/index'
import history from '../../history'
import {
  closeSiteAuditReportAlert as closeSiteAuditReportAlertAction,
  fetchAlerts,
  markAlertsAs as markAlertsAsAction,
} from '../../state/actions/alerts'
import {
  closeAdblockerModal,
  closePromptModal as closePromptModalAction,
  fetchSubscription as fetchSubscriptionAction,
  fetchUser,
  loadLanguage,
  setExtraHeaderHeight,
  updateAIWPlanModal,
  updateATPCrossSellModal,
  updateLifetimeReminderModal,
  updateLoginLimitModal as updateLoginLimitModalAction,
  updateNavigationChangeModal as updateNavigationChangeModalAction,
  updatePromptModal,
  updateUserPreferences as updateUserPreferencesAction,
} from '../../state/actions/global'
import {
  selectAlerts,
  selectSiteAuditReportReadyAlerts,
} from '../../state/selectors/alerts'
import {
  selectAIWPlanModal,
  selectATPCrossSellModal,
  selectCurrentUser,
  selectExtraHeaderHeight,
  selectIsCheckingAdblock,
  selectIsClosedAdblockDetectModal,
  selectIsDetectedAdblock,
  selectLanguageLoaded,
  selectLifetimeReminderModal,
  selectLoadingUser,
  selectLoginLimitModal,
  selectNavigationChangeModall,
  selectPromptModal,
} from '../../state/selectors/index'
import reloadBlueIcon from '../../styles/assets/tableIcons/reload-blue.svg'
import { setAffiliation } from '../../utils/affiliation'
import {
  selectProjects,
  selectCurrentProject,
  selectIsUpdatingProject,
  selectIsLoadingProjects,
} from '../Dashboard/selectors'
import {
  changeCurrentProject,
  updateProject,
  deleteProject as deleteProjectAction,
  reloadProject,
  addProject,
  fetchProjects,
} from '../Dashboard/actions'
import AddProjectModal from '../AddProjectModal/index'
import PurchaseAddonModal from '../Settings/ManageAddons/PurchaseAddonModal'
import {
  getAddonByKey,
  getAddonPrice,
  getAddonByCode,
  getAddonTypeFromCode,
  getCurrencyAndRegion,
  getSubscriptionPlanPrice,
  getAddonLimit,
  AddonCardIcons,
  isAIWAddon,
  getPlans,
} from '../../utils/payment'
import { allAddonsTypes } from '../../utils/addonTypes'
import { formatNumber } from '../../utils/numbers'
import {
  isSubUser,
  signOut,
  isSignedIn,
  isConfirmedUser,
  isEnterpriseUser,
  isEnterpriseAdmin,
} from '../../utils/userAuth'
import {
  clearToken,
  getUnloggedUserProject,
  hasUnloggedUserProject,
  removeUnloggedUserProject,
  saveRecentProject,
} from '../../utils/storage'
import {
  RECAPTCHA_SITE_KEY,
  DISABLE_RECAPTCHA,
  forceRecaptchaPaths,
  skipCreditLimitPromptPaths,
  skipEmailConfirmAlertPaths,
  skipExitIntentModalPaths,
  skipLimitPromptPaths,
  skipNavBarPaths,
  skipPastDueNoticePaths,
  skipSideBarPaths,
  enableProjectCreationOnUnloggedPaths,
  CONTENT_INTEGRATION_ROUTE,
  SHOW_ATP_LIFETIME_MODAL_PLANS,
} from '../../utils/consts.mjs'
import {
  getGrowthbookUserId,
  growthBook,
  growthbookFeatures,
} from '../../utils/growthbook'
import { Mixpanel, MIXPANEL_PROPS } from '../../utils/mixpanel'
import { checkoutModalHandler } from '../../utils/sendMessage'
import { openSuggestFeatureLink } from '../../utils/suggestFeature'
import { withGrowthbookFeature } from '../../utils/withGrowthbookFeature'
import { SiteAuditReportAlert } from '../Alerts/styled'
import NavBar from '../NavBar/index'
import UberRouter from '../Router/index'
import SideBar from '../SideBar/index'

import {
  Body,
  EmailConfirmAlert,
  EmailConfirmText,
  LayoutWrapper,
  Page,
} from './styled'

export const AppContext = createContext(null)

class Layout extends Component {
  constructor(props) {
    super(props)

    props.loadLanguage()

    const parsed = parse(window.location.search)

    if (parsed['purchase-button-location']) {
      const { 'purchase-button-location': purchaseButtonLocation, ...rest } =
        parsed

      const newUrl = window.location.pathname

      window.history.pushState({}, '', `${newUrl}?${new URLSearchParams(rest)}`)

      Mixpanel.saveLastPurchaseButtonLocation(purchaseButtonLocation)
    }

    const isChekoutModalOpen =
      parsed.checkout === 'true' &&
      parsed.action !== 'add_project_checkout' &&
      !parsed.signup

    if (isChekoutModalOpen) {
      Mixpanel.startRecording()
      trackEvent({
        event: EVENTS.NEW_CHECKOUT_MODAL_VIEW,
      })
    }

    this.state = {
      contextValue: {
        contextValue: {},
        setAppContext: this.setAppContext,
      },
      getLifetimeOffer: false,
      upgradePopup: {
        isOpen: false,
      },
      exitIntentModal: {
        isOpen: false,
        openedOnce: false,
      },
      pastDueModal: {
        isOpen: false,
      },
      projectSettingsModal: {
        isOpen: false,
      },
      purchaseAddonModal: {
        isOpen: false,
      },
      emailConfirmModal: {
        isOpen: false,
      },
      isOpenPaymentErrorModal: {
        isOpen: false,
      },
      isErrorModalOpen: {
        isOpen: false,
      },
      checkoutModal: {
        isOpen: isChekoutModalOpen,
      },
      isOpenAddProjectModal: false,
      isOpenUpdatePaymentMethodModal: false,
      updatePaymentMethodError: null,
      selectedProject: props.currentProject,
      isCollapsed: window.innerWidth > 1280,
      verificationStatus: null,
      hideTooltip: false,
      openSuggestFeature: false,
    }
    this.emailConfirmAlertRef = React.createRef()
    this.emailConfirmAlertMobileRef = React.createRef()
  }

  componentDidMount() {
    const { currentProject } = this.props
    window.addEventListener('message', this.receiveMessage, false)
    window.addEventListener('resize', this.handleResizeEvent)

    setZendeskLocation()

    const externalReferrer = sessionStorage.getItem('external_referrer')

    if (!externalReferrer && document.referrer) {
      const referrerUrl = new URL(document.referrer)
      const currentUrl = new URL(window.location.href)

      if (referrerUrl.hostname !== currentUrl.hostname) {
        sessionStorage.setItem('external_referrer', document.referrer)
      }
    }

    this.saveUtmParameters()

    this.unlisten = history.listen((location) => {
      this.blockPastDueUser(location)

      if (
        !isPaidUser() &&
        DISABLE_RECAPTCHA === 'false' &&
        forceRecaptchaPaths.some((path) => location.pathname.indexOf(path) > -1)
      ) {
        recaptchaTokenValut.reset()
        recaptchaTokenValut.getToken().then()
      }
    })

    const parsed = parse(window.location.search)

    if (parsed.googleAuth === 'true') {
      const { googleAuth: _, ...rest } = parsed
      history.replace({
        search: stringify(rest),
      })
    }

    if (parsed.action === 'add_project_checkout') {
      const { action: _, ...rest } = parsed
      history.replace({
        search: stringify(rest),
      })

      this.openAddProjectModal({ isCheckoutModalOpen: true })
    }

    if (parsed.action === 'suggest-feature') {
      this.setState({
        openSuggestFeature: true,
      })

      const { action: _, ...rest } = parsed

      history.replace({
        search: stringify(rest),
      })
    }

    if (parsed.email && parsed.verification_status) {
      if (isSignedIn()) {
        if (parsed.verification_status === 'confirmed') {
          this.setState({
            verificationStatus: {
              email: parsed.email,
              status: parsed.verification_status,
            },
          })
          setTimeout(() => {
            this.setState({
              verificationStatus: null,
            })
          }, 10000)
        }
      } else {
        this.handleShowAuth({
          type: 'login',
          verificationStatus: {
            email: parsed.email,
            status: parsed.verification_status,
          },
          next: window.location.pathname,
        })
        return
      }
      pushWithLanguageRoutes(window.location.pathname)
    }

    if (!isSignedIn() && parsed && parsed.loginModal) {
      this.handleShowAuth({
        type: 'login',
      })
    }

    if (currentProject) {
      this.setState({
        selectedProject: currentProject,
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      user,
      projects,
      currentProject,
      updateExtraHeaderHeight,
      extraHeaderHeight,
    } = this.props
    const { checkoutModal, openSuggestFeature, contextValue } = this.state

    const parsed = parse(window.location.search)
    if (
      !prevState.checkoutModal.isOpen &&
      !checkoutModal.isOpen &&
      parsed.checkout === 'true' &&
      parsed.action !== 'add_project_checkout' &&
      !parsed.signup
    ) {
      this.setState({
        checkoutModal: {
          isOpen: true,
        },
      })
      Mixpanel.startRecording()
      trackEvent({
        event: EVENTS.NEW_CHECKOUT_MODAL_VIEW,
      })
    }

    if (currentProject && !isEqual(currentProject, prevProps.currentProject)) {
      this.setState({
        selectedProject: currentProject,
      })
    }

    const emailRef =
      window.innerWidth > 768
        ? this.emailConfirmAlertRef
        : this.emailConfirmAlertMobileRef

    if (extraHeaderHeight !== emailRef.current?.offsetHeight) {
      updateExtraHeaderHeight(emailRef.current?.offsetHeight)
    }

    trackMonthlyExperiment({ user })

    if (!prevProps.user && user) {
      const { getLifetimeOffer } = this.state

      setAffiliation()

      if (openSuggestFeature) {
        this.setState({
          openSuggestFeature: false,
        })

        openSuggestFeatureLink()
      }

      if (
        !getLifetimeOffer &&
        !isPaidUser() &&
        user?.tier === 'free' &&
        !user?.flags?.lifetime5_offer_accepted &&
        parsed?.appCoupon
      ) {
        this.setState({
          openIntentExitModal: true,
        })
      }
      delete parsed.appCoupon
      const updatedQueryString = stringify(parsed)
      let newUrl = window.location.pathname
      if (updatedQueryString) newUrl += `?${updatedQueryString}`
      window.history.pushState({}, '', newUrl)
    } else if (
      prevProps.user &&
      user &&
      (prevProps.user?.tier !== user?.tier ||
        prevProps.user?.subscription?.planInterval !==
          user?.subscription?.planInterval)
    ) {
      growthBook.setAttributes({
        id: getGrowthbookUserId(),
        userId: user.id,
        tier: user?.tier || 'unlogged',
        affiliation: user?.affiliation || false,
        planInterval: user
          ? user?.subscription?.planInterval || 'free'
          : 'unknown',
      })
    }

    if (prevState.contextValue !== contextValue) {
      this.setState({
        contextValue: {
          contextValue,
          setAppContext: this.setAppContext,
        },
      })
    }

    if (
      hasUnloggedUserProject() &&
      isSignedIn() &&
      projects &&
      enableProjectCreationOnUnloggedPaths.some((path) =>
        window.location.pathname.includes(path),
      )
    ) {
      const { addProject: addProjectFunc, updateUserInfo } = this.props

      const unloggedUserProject = getUnloggedUserProject()
      const {
        domain,
        keywords,
        competitors,
        competitorsLocations,
        locations,
        rankTrackingFrequency,
        mobileRankTracking,
        leadsData,
        eventProps,
      } = unloggedUserProject

      const keywordsAsConfig = keywords.reduce((config, kw) => {
        config[kw] = locations.map((loc) => ({
          loc_id: loc.id,
          lang: loc.languageCode,
        }))
        return config
      }, {})

      const competitorsAsConfig = competitors.reduce((config, ct) => {
        config[ct.domain] = competitorsLocations.map((loc) => ({
          loc_id: loc.id,
          lang: loc.languageCode,
        }))
        return config
      }, {})

      addProjectFunc(
        {
          domain,
          title: domain,
          locations: locations.map((loc) => ({
            loc_id: loc.id,
            lang: loc.languageCode,
          })),
          keywords: keywordsAsConfig,
          competitorsLocations: competitorsLocations.map((loc) => ({
            loc_id: loc.id,
            lang: loc.languageCode,
          })),
          competitors: competitorsAsConfig,
          rankTrackingFrequency,
          mobileRankTracking,
        },
        leadsData,
        ({ data }) => {
          if (data) {
            trackEvent({
              event: EVENTS.PROJECT_CREATION_SUCCESS,
              mixpanelProperties: [
                {
                  ...eventProps,
                  locations: uniq(map(locations, 'name')),
                  languages: uniq(map(locations, 'languageCode')),
                  keywords,
                  skippedAddKeywords: !keywords.length,
                  competitors,
                  skippedAddCompetitors: !competitors.length,
                  agencyOfferResponse: !!leadsData,
                },
              ],
            })

            return updateUserInfo()
          }

          const sanitizedDomain = sanitizeDomain(domain)
          const hasDomain = projects?.some(
            (project) => project.domain === sanitizedDomain,
          )

          if (hasDomain) {
            this.openAddProjectModal({ domain, activeStep: 1 })
            return sendMessage('URL_ALREADY_USED')
          }

          this.showPromptModal(
            translate('project_prompt_headline'),
            translate('project_prompt_text'),
            {
              [PROPERTY_NAMES.btn_location]:
                PROPERTY_VALUES.dashboard.new_project_header,
              btnLocation:
                MIXPANEL_PROPS.PURCHASE_BUTTON_LOCATION.values
                  .LIMIT_REACHED_MODAL,
            },
            false,
          )
        },
      )

      removeUnloggedUserProject()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.receiveMessage, false)

    window.removeEventListener('resize', this.handleResizeEvent)

    if (this.removeExitIntent) this.removeExitIntent()
    if (this.unlisten) this.unlisten()
  }

  saveUtmParameters = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const utmParams = {
      utm_source: urlParams.get('utm_source'),
      utm_medium: urlParams.get('utm_medium'),
      utm_campaign: urlParams.get('utm_campaign'),
      utm_term: urlParams.get('utm_term'),
      utm_content: urlParams.get('utm_content'),
      last_campaign_source: urlParams.get('last_campaign_source'),
    }

    const filteredUtmParams = Object.fromEntries(
      Object.entries(utmParams).filter(([_, value]) => value !== null),
    )

    if (Object.keys(filteredUtmParams).length > 0) {
      sessionStorage.setItem(
        'utm_parameters',
        JSON.stringify(filteredUtmParams),
      )
      Mixpanel.register(utmParams)
    }

    this.cleanUtmParamsFromUrl()
  }

  cleanUtmParamsFromUrl = () => {
    const parsed = parse(window.location.search)
    const utmKeys = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'last_campaign_source',
    ]

    utmKeys.forEach((key) => {
      if (parsed[key]) delete parsed[key]
    })

    const newUrl = window.location.pathname
    const queryString = stringify(parsed)

    window.history.replaceState(
      {},
      '',
      queryString ? `${newUrl}?${queryString}` : newUrl,
    )
  }

  setAppContext = (newValue) => {
    this.setState({ contextValue: newValue })
  }

  handleResizeEvent = () => {
    const emailRef =
      window.innerWidth > 768
        ? this.emailConfirmAlertRef
        : this.emailConfirmAlertMobileRef

    setTimeout(
      () => this.props.updateExtraHeaderHeight(emailRef.current?.offsetHeight),
      50,
    )
  }

  handleShowAuth = (info) => {
    const parsed = parse(window.location.search)
    if (parsed && parsed.loginModal) delete parsed.loginModal

    const type = info?.type || 'login'
    const currentUrl =
      window.location.pathname +
      (stringify(parsed) ? `?${stringify(parsed)}` : '') +
      window.location.hash
    const next = info?.next || currentUrl
    if (type === 'register') {
      pushWithLanguageRoutes(`/register`, { next })
    } else {
      pushWithLanguageRoutes(`/login`, {
        next,
        verificationStatus: info?.verificationStatus,
      })
    }
  }

  kissmetricsTracking = (tier, plan, paymentMethod) => {
    kissmetricsRecordingEvent(KISSMETRICS_TRACK_EVENTS.user_upgraded, {
      [PROPERTY_NAMES.payment_method]:
        paymentMethod === 'paypal'
          ? PROPERTY_VALUES.payment_method.paypal
          : PROPERTY_VALUES.payment_method.credit_card,
      [PROPERTY_NAMES.plan_tier]: PROPERTY_VALUES.plan_tier[tier],
      [PROPERTY_NAMES.billing_plan]: PROPERTY_VALUES.billing_plan[plan],
    })
  }

  blockPastDueUser = (location) => {
    if (
      shouldBlockPastDue(this.props.user) &&
      !skipPastDueNoticePaths.some((path) => location.pathname.endsWith(path))
    ) {
      this.setState({ pastDueModal: { isOpen: true } })
    } else {
      this.setState({ pastDueModal: { isOpen: false } })
    }
  }

  receiveMessage = (event) => {
    const { user } = this.props

    const canBuyAddon = isPaidUser() && !isSubUser(user)

    if (event.origin !== window.location.origin) return
    const message =
      typeof event.data === 'string' ? event.data : event.data.message
    if (message?.error === 'BILLING_ERROR') {
      this.setState({
        isOpenPaymentErrorModal: {
          isOpen: true,
          ...message,
        },
      })
    }
    if (message === 'ERROR_MODAL') {
      this.setState({
        isErrorModalOpen: {
          isOpen: true,
          ...message,
        },
      })
    }

    if (
      message === 'LIMIT_REACHED' &&
      !skipLimitPromptPaths.some(
        (path) => history.location.pathname.indexOf(path) > -1,
      )
    ) {
      if (!isSignedIn()) {
        Mixpanel.saveRegisterClickPageName()
        this.handleShowAuth({
          type: 'register',
          next: event.data.info?.next,
        })
        return
      }

      const isAIWriterLimit =
        history.location.pathname.indexOf(CONTENT_INTEGRATION_ROUTE) > -1

      this.showPromptModal(
        isPaidUser()
          ? translate('upgrade_report_limit_heading')
          : translate('upgrade_free_search_limit_heading'),
        isPaidUser()
          ? translate('upgrade_report_limit_text')
          : translate('upgrade_free_search_limit_text'),
        {
          [PROPERTY_NAMES.btn_location]:
            PROPERTY_VALUES.upgrade_to_keep_using_prompt,
          btnLocation:
            MIXPANEL_PROPS.PURCHASE_BUTTON_LOCATION.values.LIMIT_REACHED_MODAL,
        },
        true,
        null,
        false,
        canBuyAddon &&
          !isAIWriterLimit &&
          getAddonByKey(user?.addons, allAddonsTypes.ADDON_DAILYSEARCH)
          ? allAddonsTypes.ADDON_DAILYSEARCH
          : null,
      )
    } else if (message === 'REFRESH_SERP_LIMIT_REACHED') {
      let title = ''
      let messageContent = ''
      if (!isSignedIn()) {
        // unlogged user
        title = translate('unlogged_credits_limit_heading')
        messageContent = translate('unlogged_serp_credits_limit_subheading')
      } else if (isPaidUser()) {
        // paid user
        title = translate('credits_limit_heading')
        messageContent = isSubUser()
          ? // invited user
            translate(
              'subuser_credits_limit_subheading',
              user.mainUser.email || '',
            )
          : // paid account
            translate('credits_limit_subheading')
      } else if (isFreeTrialUsed()) {
        // free trial user
        title = translate('no_trial_credits_limit_heading')
        messageContent = translate('no_trial_credits_limit_subheading')
      } else {
        // free user
        title = translate('free_user_credits_limit_heading')
        messageContent = translate('free_user_credits_limit_subheading')
      }

      this.showPromptModal(
        title,
        messageContent,
        {
          btnLocation:
            MIXPANEL_PROPS.PURCHASE_BUTTON_LOCATION.values.UPDATE_METRICS_MODAL,
        },
        false,
        'credits',
        false,
        canBuyAddon &&
          getAddonByKey(
            user.addons,
            allAddonsTypes.ADDON_KEYWORD_METRICS_UPDATES,
          )
          ? allAddonsTypes.ADDON_KEYWORD_METRICS_UPDATES
          : null,
      )
    } else if (
      message === 'KEYWORD_METRICS_UPDATE_LIMIT_REACHED' &&
      !skipCreditLimitPromptPaths.some(
        (path) => history.location.pathname.indexOf(path) > -1,
      )
    ) {
      const forceUpgrade = event.data.info?.forceUpgrade ?? false
      const isBulk = event.data.info?.isBulk ?? false
      const useGeneralUpgrade = event.data.info?.useGeneralUpgrade ?? false
      let title = ''
      let messageContent = ''
      let propertyName = ''
      let propertyValue = ''

      if (!isSignedIn()) {
        // unlogged user
        title = forceUpgrade
          ? translate('unlock_free_trial')
          : translate('unlogged_credits_limit_heading')
        messageContent = forceUpgrade
          ? translate('free_user_credits_limit_subheading')
          : translate('unlogged_credits_limit_subheading')
        propertyName = forceUpgrade
          ? PROPERTY_NAMES.my_free_trial_btn_location
          : PROPERTY_NAMES.btn_location
        propertyValue = isBulk
          ? PROPERTY_VALUES.sd_refresh_modal_prompt.bulk
          : PROPERTY_VALUES.sd_refresh_modal_prompt.singleKeyword
      } else if (isPaidUser()) {
        // paid user
        title = translate('credits_limit_heading')
        messageContent = isSubUser()
          ? translate(
              'subuser_credits_limit_subheading',
              user.mainUser.email || '',
            )
          : translate('credits_limit_subheading')
        propertyName = PROPERTY_NAMES.btn_location
        propertyValue = isBulk
          ? PROPERTY_VALUES.sd_refresh_modal_prompt.bulk
          : PROPERTY_VALUES.sd_refresh_modal_prompt.singleKeyword
      } else if (isFreeTrialUsed()) {
        // free trial user

        title = useGeneralUpgrade
          ? translate('unlock_all')
          : translate('free_user_credits_limit_heading')
        messageContent = translate('update_metrics_block_no_trial')
        propertyName = PROPERTY_NAMES.btn_location
        propertyValue = isBulk
          ? PROPERTY_VALUES.sd_refresh_modal_prompt.bulk
          : PROPERTY_VALUES.sd_refresh_modal_prompt.singleKeyword
      } else {
        // free user

        title = useGeneralUpgrade
          ? translate('unlock_free_trial')
          : translate('free_user_credits_limit_heading')
        messageContent = translate('free_user_credits_limit_subheading')
        propertyName = PROPERTY_NAMES.my_free_trial_btn_location
        propertyValue = isBulk
          ? PROPERTY_VALUES.sd_refresh_modal_prompt.bulk
          : PROPERTY_VALUES.sd_refresh_modal_prompt.singleKeyword
      }
      this.showPromptModal(
        title,
        messageContent,
        {
          [propertyName]: propertyValue,
          btnLocation:
            MIXPANEL_PROPS.PURCHASE_BUTTON_LOCATION.values.UPDATE_METRICS_MODAL,
        },
        forceUpgrade,
        'credits',
        false,
        canBuyAddon &&
          getAddonByKey(
            user.addons,
            allAddonsTypes.ADDON_KEYWORD_METRICS_UPDATES,
          )
          ? allAddonsTypes.ADDON_KEYWORD_METRICS_UPDATES
          : null,
      )
    } else if (message === 'SIGN_OUT_WARNING') {
      this.props.updateLoginLimitModal({
        isOpen: true,
        type: 'SIGN_OUT_WARNING',
        title: translate('signed_out_warning'),
        message: translate('signed_out_warning_text'),
      })
    } else if (message === 'SHOW_PROMPT') {
      const { info } = event.data

      this.showPromptModal(
        info.title,
        info.message,
        info.eventProperty,
        info.forceUpgrade,
        info.from,
        info.showLoginLink,
        info.addonType,
        info.next,
        info.addonProjectId,
        info.initialProjectData,
      )
    } else if (message === 'SUBSCRIPTION_UPGRADED') {
      const {
        tier,
        plan,
        paymentMethod,
        next,
        hasAIWAddon = false,
        promo,
        utmParams,
        modalText = 'subscription_upgraded',
      } = event.data.info
      this.showPlanUpgradeModal(
        promo
          ? translate('holiday_offer_confirm_heading')
          : translate('subscription_status'),
        promo ? translate('holiday_sale_confirmed') : translate(modalText),
        next,
        tier !== 'tier0' &&
          tier !== 'restart' &&
          !hasAIWAddon &&
          isPaidUser() &&
          !isFreeTrialUser(),
        tier,
        true,
        utmParams,
      )
      this.kissmetricsTracking(tier, plan, paymentMethod)
    } else if (message === 'SUBSCRIPTION_DOWNGRADED') {
      this.updateUserInfo()
      const { utmParams } = event.data.info
      this.openATPCrossSellModal(false, undefined, utmParams)
    } else if (message === 'MODAL_SUBSCRIPTION_UPGRADED') {
      if (
        !SHOW_ATP_LIFETIME_MODAL_PLANS.includes(
          user?.subscription?.planInterval,
        )
      )
        return
      const { tier, plan, paymentMethod, utmParams } = event.data.info
      this.updateUserInfo()
      this.kissmetricsTracking(tier, plan, paymentMethod)
      this.openATPCrossSellModal(true, undefined, utmParams)
    } else if (message === 'MODAL_SUBSCRIPTION_DOWNGRADED') {
      if (
        !SHOW_ATP_LIFETIME_MODAL_PLANS.includes(
          user?.subscription?.planInterval,
        )
      )
        return
      const { utmParams } = event.data.info
      this.updateUserInfo()
      this.openATPCrossSellModal(true, undefined, utmParams)
    } else if (message === 'UPDATE_ALERTS') {
      this.updateAlerts(event.data.info)
    } else if (message === 'MODAL_ADDON_PURCHASED') {
      const { addonType, projectId } = event.data.info
      if (addonType === allAddonsTypes.ADDON_DAILYSEARCH) clearToken()
      this.updateUserInfo()
      if (projectId) this.props.reloadProject(projectId)
    } else if (message === 'SHOW_AUTH') {
      this.handleShowAuth(event.data.info)
    } else if (message === 'SHOW_UPDATE_BILLING_INFO_MODAL') {
      this.setState({
        isOpenUpdatePaymentMethodModal: true,
        updatePaymentMethodError: null,
      })
    } else if (message === 'SHOW_EMAIL_CONFIRM_MODAL') {
      const email = event.data.info?.email
      const hideRefreshButton = event.data.info?.hideRefreshButton
      const hideCloseIcon = event.data.info?.hideCloseIcon

      if (email)
        this.showEmailConfirmModal(email, hideRefreshButton, hideCloseIcon)
    } else if (message === 'ADD_PROJECT') {
      const { initialProjectData, eventProperty } = event.data.info
      if (eventProperty?.addProjectButtonLocation) {
        trackEvent({
          event: EVENTS.PROJECT_CREATION_CLICK,
          mixpanelProperties: [eventProperty?.addProjectButtonLocation],
        })
      }
      this.openAddProjectModal(initialProjectData, eventProperty)
    } else if (message === 'SHOW_CHECKOUT_MODAL') {
      this.setState({
        checkoutModal: {
          isOpen: true,
        },
        hideTooltip: true,
      })
      Mixpanel.startRecording()
      trackEvent({
        event: EVENTS.NEW_CHECKOUT_MODAL_VIEW,
      })
    } else if (message === 'NEW_PROJECT_SAVED') {
      this.setState({
        purchaseAddonModal: { isOpen: false },
      })
    }
  }

  updateUserInfo = (onComplete) => {
    this.props.updateUserInfo(onComplete)
  }

  updateAlerts = (info) => {
    this.props.updateAlerts(info)
  }

  handleToggleCollapse = (e, force) => {
    this.setState((prevState) => ({
      isCollapsed: force || !prevState.isCollapsed,
    }))
  }

  showEmailConfirmModal = (
    email,
    hideRefreshButton = false,
    hideCloseIcon = false,
  ) => {
    this.setState({
      emailConfirmModal: {
        isOpen: true,
        email,
        hideRefreshButton,
        hideCloseIcon,
      },
    })
  }

  closeEmailConfirmModal = () => {
    this.setState({
      emailConfirmModal: {
        isOpen: false,
      },
    })
  }

  showPromptModal = (
    title,
    message,
    eventProperty,
    forceUpgrade = false,
    from = '',
    showLoginLink = false,
    addonType = null,
    next = null,
    addonProjectId = null,
    initialProjectData = {},
  ) => {
    this.props.updatePromptModal({
      isOpen: true,
      title,
      message,
      forceUpgrade,
      eventProperty,
      from,
      showLoginLink,
      addonType,
      next,
      addonProjectId,
      initialProjectData,
      isEnterpriseUser: isEnterpriseUser() || isEnterpriseAdmin(),
    })
  }

  showPlanUpgradeModal = (
    title,
    message,
    next,
    tier,
    utmParams,
    showAIWPlanModal = false,
    isUpgraded = false,
  ) => {
    this.setState({
      upgradePopup: {
        isOpen: true,
        title,
        message,
        next,
        showAIWPlanModal,
        tier,
        isUpgraded,
        utmParams,
      },
    })
  }

  hideLifetimeReminderModal = () =>
    this.props.updateLifetimeReminderModal({
      isOpen: false,
    })

  handleChangeProject = (project) => {
    if (project && this.state.selectedProject.id !== project.id) {
      saveRecentProject(project)
      this.props.changeCurrentProject(project.id)
    }
  }

  openAddProjectModal = (initialProjectData = {}, eventProps = {}) => {
    const parsed = parse(window.location.search)
    const { titleUpgradePlan, reachedText, ...rest } = parsed
    history.replace({
      search: stringify(rest),
    })

    this.setState({
      isOpenAddProjectModal: true,
      initialAddProjectData: {
        ...initialProjectData,
        titleUpgradePlan: titleUpgradePlan || '',
        reachedText: reachedText || '',
      },
      addProjectEventProps: eventProps,
    })
  }

  closeAddProjectModal = (newAddonProject = false) => {
    this.setState({ isOpenAddProjectModal: false })
    history.replace()
    if (newAddonProject) this.props.fetchSubscription()
  }

  finishProjectCreation = (newAddonProject = false) => {
    this.closeAddProjectModal(newAddonProject)
    const parsed = parse(window.location.search)
    if (
      parsed.from === 'ai_writer' &&
      parsed.action === 'add_project' &&
      parsed.next
    ) {
      window.location.href = parsed.next
    }
  }

  handleSaveProject = (projectId, data, onError) => {
    this.props.updateProject(projectId, data, ({ error }) => {
      if (error) {
        // here error.response.data.error.code should be 'invalid_domain`
        onError(error.response.data)
      } else {
        this.setState({
          projectSettingsModal: {
            isOpen: false,
          },
        })
      }
    })
  }

  handleEditProject = (project) => {
    this.setState({
      projectSettingsModal: {
        isOpen: true,
        project,
      },
    })
  }

  showPurchaseAddonModal = (
    addonType,
    addonProjectId = null,
    initialProjectData = {},
  ) => {
    const { user } = this.props
    const { subscription } = user
    const availableAddons = user.addons || {}
    const addonDetail = getAddonByKey(availableAddons, addonType)

    if (!addonType || !subscription || !addonDetail) return null

    const plan = subscription.planInterval
    const purchasedAddons = user.subscription?.addOns
    const { region, currency, planCode } = getCurrencyAndRegion(
      user.countryCode,
    )
    const subscriptionPrice =
      getSubscriptionPlanPrice(
        user.countryCode,
        user.subscription.tier,
        plan,
      ) || 0
    let addonsPrice = 0
    let quantity = 1
    if (availableAddons && purchasedAddons && purchasedAddons.length > 0) {
      for (let i = 0; i < purchasedAddons.length; i += 1) {
        const purchasedAddonDetail = getAddonByCode(
          availableAddons,
          purchasedAddons[i].code,
        )
        const purchasedAddonType = getAddonTypeFromCode(purchasedAddons[i].code)

        if (purchasedAddonDetail && purchasedAddonType) {
          addonsPrice +=
            getAddonPrice(purchasedAddonDetail, currency, planCode) *
            purchasedAddons[i].quantity
          if (
            purchasedAddonType === addonType &&
            ((!addonProjectId && !purchasedAddons[i].project_id) ||
              (addonProjectId &&
                purchasedAddons[i].project_id === addonProjectId))
          )
            quantity = purchasedAddons[i].quantity + 1
        }
      }
    }

    const addonPrice = addonDetail
      ? getAddonPrice(addonDetail, currency, planCode)
      : 0
    const totalPrice =
      (plan === 'lifetime' ? 0 : subscriptionPrice) + addonsPrice + addonPrice

    const planInterval = translate('month_value')
    const totalPlan = 'month_value'

    let selectedProject

    if (addonProjectId)
      selectedProject = this.props.projects.find((p) => p.id === addonProjectId)

    if (!isAIWAddon(addonType)) {
      trackEvent({
        event: EVENTS.BUY_ADDON_CLICK,
        mixpanelProperties: [
          {
            user,
            addonType,
          },
        ],
      })
    }

    this.setState({
      purchaseAddonModal: {
        isOpen: true,
        selectedProject,
        addonDetail: {
          addonType,
          selectedAddonIndex: 0,
          addons: [
            {
              ...addonDetail,
              ...AddonCardIcons[addonType],
              addonType,
              title: translate(
                AddonCardIcons[addonType].text,
                `+${getAddonLimit(addonDetail)}`,
              ),
              addonPrice: translate(
                'value_per_plan',
                formatNumber(addonPrice, true, 2, region, false),
                planInterval,
              ),
              newTotalPrice: translate(
                'new_total',
                formatNumber(totalPrice, true, 2, region, false),
                translate(totalPlan),
              ),
              billingChangeSummary: translate(
                'billing_changes_summary_addon_purchase',
                formatNumber(addonPrice, true, 2, region, false),
                planInterval,
              ),
              quantity,
            },
          ],
        },
        initialProjectData,
      },
    })
  }

  handlePurchaseAddon = ({
    addon: addonDetail,
    project,
    initialProjectData = {},
    successCallback,
    from = '',
  }) => {
    purchaseAddons(addonDetail.code, project?.id)
      .then(() => {
        const { user } = this.props
        const { addonType } = addonDetail

        if (!isAIWAddon(addonType)) {
          Mixpanel.trackBuyAddonSuccess({
            user,
            addonType,
            addonAction: {
              code: addonDetail?.code,
              event: 'add',
            },
          })
        }

        if (addonDetail.addonType === allAddonsTypes.ADDON_DAILYSEARCH)
          clearToken()

        this.updateUserInfo(() => {
          if (
            addonDetail.addonType === allAddonsTypes.ADDON_DOMAIN &&
            from !== 'add_project_modal' &&
            from !== 'add_project_modal_with_leads_data' &&
            from !== 'create_project_one_click'
          ) {
            this.openAddProjectModal(initialProjectData)
          }
        })

        if (
          (addonDetail.addonType === allAddonsTypes.ADDON_TRACKEDKEYWORDS ||
            addonDetail.addonType === allAddonsTypes.ADDON_COMPETITOR) &&
          project
        )
          this.props.reloadProject(project.id)

        if (
          from !== 'add_project_modal' &&
          from !== 'add_project_modal_with_leads_data'
        ) {
          this.setState({
            purchaseAddonModal: { isOpen: false, from },
          })
        }

        this.props.closePromptModal()
        successCallback()

        if (from === 'add_project_modal') {
          sendMessage('SAVE_NEW_PROJECT')
        }

        if (from === 'add_project_modal_with_leads_data') {
          sendMessage('SAVE_NEW_PROJECT_WITH_LEADS_DATA')
        }
      })
      .catch((error) => {
        console.error('error', error)
        this.setState({
          purchaseAddonModal: { isOpen: false },
        })
      })
  }

  handleResendVerificationEmail = (email) => {
    const lang = getLanguageCode()

    resendVerificationEmail({ email, lang })

    if (isSignedIn() && !this.state.emailConfirmModal.hideRefreshButton) {
      this.setState((prevState) => ({
        emailConfirmModal: {
          isOpen: true,
          email,
          isSentEmail: true,
          hideCloseIcon: prevState.emailConfirmModal.hideCloseIcon,
        },
      }))
    } else {
      this.setState({
        emailConfirmModal: {
          isOpen: false,
        },
      })
    }
  }

  renderEmailConfirmButton = (email, style = {}) => (
    <div
      role="button"
      tabIndex={0}
      style={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        minWidth: '200px',
        ...style,
      }}
      onClick={() => this.handleResendVerificationEmail(email)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          this.handleResendVerificationEmail(email)
        }
      }}
    >
      <Icon
        src={reloadBlueIcon}
        width="20px"
        height="20px"
        margin="0 8px 0 0"
      />
      <Text
        lineHeight="20px"
        fontFamily={fonts.primaryBook}
        color={palette.blue}
        textTransform="capitalize"
        cursor="pointer"
      >
        {translate('resend_confirmation_button')}
      </Text>
    </div>
  )

  closeAdblockDetectModal = (isDisabled = false) => {
    this.props.closeAdblockDetectModal()
    if (isDisabled) window.location.reload()
  }

  openAIWPlanModal = (tier, next, fromModal = false) => {
    const { user } = this.props
    const isSubUserAccount = isSubUser(user)

    if (isSubUserAccount) return

    this.props.updateAIWPlanModal({
      isOpen: true,
      tier,
      next,
      fromModal,
    })
  }

  handleCloseAIWPlanModal = () => {
    const { projects, aiwPlanModal } = this.props

    if (aiwPlanModal.fromModal) {
      this.props.updateAIWPlanModal({
        isOpen: false,
      })
      return
    }

    window.location =
      this.props.aiwPlanModal.next ||
      `/${getLanguageCode()}/dashboard${
        projects && projects.length > 0 ? '' : '?action=add_project'
      }`

    this.props.updateAIWPlanModal({
      isOpen: false,
    })
  }

  openATPCrossSellModal = (fromModal, next, utmParams) => {
    const { user } = this.props
    if (
      user?.subscription &&
      !SHOW_ATP_LIFETIME_MODAL_PLANS.includes(user?.subscription?.planInterval)
    )
      return
    const hasAtp = sessionStorage.getItem('hatp')
    this.props.updateATPCrossSellModal({
      isOpen: hasAtp !== 'true',
      fromModal,
      next,
      utmParams,
    })
  }

  handleCloseATPCrossSellModal = (isOpen) => {
    if (isOpen) {
      trackEvent({ event: EVENTS.ATP_CROSS_SELL_MODAL_CLICK })
      if (this.props?.atpCrossSellModal?.next) {
        const nextUrl = this.props.atpCrossSellModal.next.includes('http')
          ? new URL(this.props.atpCrossSellModal.next)
          : this.props.atpCrossSellModal.next
        const historyPath = nextUrl?.pathname || nextUrl
        history.replace(historyPath)
      }

      if (this.props?.atpCrossSellModal) {
        const utmId = 'ubs-cross-sell-atp'
        const utmCampaign = 'atp_cross_sell_no_discount'
        const { utmParams } = this.props.atpCrossSellModal

        const searchParams = new URLSearchParams({
          'utm-source': utmParams.source,
          'utm-medium': utmParams.medium,
          'utm-campaign': utmCampaign,
          'utm-id': utmId,
        })

        window.open(
          `http://answerthepublic.com/pricing/?${searchParams}`,
          '_blank',
        )
        this.props.updateATPCrossSellModal({
          isOpen: false,
        })
        return
      }

      window.open(`http://answerthepublic.com/pricing`, '_blank')
      this.props.updateATPCrossSellModal({
        isOpen: false,
      })
    } else {
      const { atpCrossSellModal } = this.props
      if (atpCrossSellModal.fromModal) {
        this.props.updateATPCrossSellModal({
          isOpen: false,
        })
        return
      }

      const { projects } = this.props

      window.location =
        atpCrossSellModal.next ||
        `/${getLanguageCode()}/dashboard${
          projects && projects.length > 0 ? '' : '?action=add_project'
        }`
    }
  }

  closeIntentExitModal() {
    this.setState({ openIntentExitModal: false })
  }

  stopRecording() {
    const blockedPaths = ['/ubersuggest/overview', '/ubersuggest/keyword_ideas']
    const currentPath = new URL(window.location.href).pathname
    if (blockedPaths.some((path) => currentPath.includes(path))) {
      return
    }
    Mixpanel.stopRecording()
  }

  render() {
    const languageCode = getLanguageCode()
    const {
      languageLoaded,
      loadingUser,
      user,
      alerts,
      lifetimeReminderModal,
      navigationChangeModal,
      aiwPlanModal,
      projects,
      loginLimitModal,
      promptModal,
      atpCrossSellModal,
      markAlertsAs,
      siteAuditReportAlert,
      closeSiteAuditReportAlert,
      isLoadingProjects,
      injectReducer,
      injectSagas,
      isUpdatingProject,
      fetchSubscription,
      deleteProject,
      updateNavigationChangeModal,
      updateUserPreferences,
      closePromptModal,
      updateLoginLimitModal,
      isDetectedAdblock,
      isClosedAdblockDetectModal,
      isGrowthbookFeatureOn,
      isGrowthbookFeatureOnInrCurrency,
    } = this.props
    const {
      upgradePopup,
      exitIntentModal,
      pastDueModal,
      isOpenPaymentErrorModal,
      selectedProject,
      purchaseAddonModal,
      isOpenUpdatePaymentMethodModal,
      updatePaymentMethodError,
      emailConfirmModal,
      verificationStatus,
      openIntentExitModal,
      contextValue,
      isCollapsed,
      hideTooltip,
      isErrorModalOpen,
      initialAddProjectData,
      isOpenAddProjectModal,
      addProjectEventProps,
      checkoutModal,
      projectSettingsModal,
    } = this.state
    const domainAddon = getAddonByKey(user?.addons, allAddonsTypes.ADDON_DOMAIN)
    const isSubUserAccount = user && isSubUser(user)
    const canBuyAddon = isPaidUser() && !isSubUserAccount
    const plansLoaded = !!getPlans()
    if (plansLoaded) {
      if (isGrowthbookFeatureOnInrCurrency) {
        sessionStorage.setItem('gbInrCur', isGrowthbookFeatureOnInrCurrency)
      } else {
        sessionStorage.removeItem('gbInrCur')
      }
    }

    let subscriptionType = 'recurly'
    if (user?.subscription)
      subscriptionType = user.subscription.subscriptionType

    return (
      <AppContext.Provider value={contextValue}>
        <>
          {!isPaidUser() && DISABLE_RECAPTCHA === 'false' && (
            <ReCAPTCHAWrapper sitekey={RECAPTCHA_SITE_KEY} />
          )}

          <LayoutWrapper>
            {!languageLoaded ? (
              <Loading />
            ) : (
              <>
                <IntentExitModal
                  isOpen={openIntentExitModal}
                  onClose={this.closeIntentExitModal}
                />
                {!loadingUser &&
                  isSignedIn() &&
                  !isConfirmedUser() &&
                  !skipEmailConfirmAlertPaths.some(
                    (path) => window.location.pathname.indexOf(path) > -1,
                  ) && (
                    <Desktop>
                      <EmailConfirmAlert ref={this.emailConfirmAlertRef}>
                        <EmailConfirmText>
                          <Text
                            lineHeight="20px"
                            fontFamily={fonts.primary}
                            boldColor={palette.darkGray}
                            dangerouslySetInnerHTML={{
                              __html: translate(
                                'confirm_email_modal_text',
                                user.email,
                              ),
                            }}
                          />
                          <Text lineHeight="20px" fontFamily={fonts.primary}>
                            {translate('check_spam_note')}
                          </Text>
                        </EmailConfirmText>
                        {this.renderEmailConfirmButton(user.email)}
                      </EmailConfirmAlert>
                    </Desktop>
                  )}
                {!skipNavBarPaths.some(
                  (path) => window.location.pathname.indexOf(path) > -1,
                ) && (
                  <NavBar
                    collapsed={isCollapsed}
                    onToggleCollapse={this.handleToggleCollapse}
                    loadingUser={loadingUser}
                    user={user}
                    path={window.location.pathname}
                    alerts={alerts}
                    closeSiteAuditReportAlert={closeSiteAuditReportAlert}
                    markAlertsAs={markAlertsAs}
                    hideTooltip={hideTooltip}
                  >
                    {Boolean(siteAuditReportAlert) && (
                      <Tooltip
                        open={!!siteAuditReportAlert}
                        interactive
                        position="bottom"
                        theme="light"
                        trigger="manual"
                        distance={26}
                        offset={-30}
                        html={
                          <SiteAuditReportAlert
                            alert={siteAuditReportAlert}
                            onClick={(alert) => {
                              pushWithLanguageRoutes(
                                `/seo_analyzer/site_audit?domain=${alert.content.domain}`,
                              )
                              closeSiteAuditReportAlert()
                            }}
                            onClose={() => closeSiteAuditReportAlert()}
                          />
                        }
                      />
                    )}
                  </NavBar>
                )}
                <Body>
                  {!skipSideBarPaths.some(
                    (path) => window.location.pathname.indexOf(path) > -1,
                  ) && (
                    <SideBar
                      user={user}
                      languageCode={languageCode}
                      collapsed={isCollapsed}
                      onToggleCollapse={this.handleToggleCollapse}
                      handleClickSupport={() =>
                        // todo: check for mixpanel purchase click event
                        this.showPromptModal(
                          translate('support_prompt_headline'),
                          translate('support_prompt_text'),
                        )
                      }
                      selectedProject={selectedProject}
                      projects={projects}
                      handleChangeProject={this.handleChangeProject}
                      handleAddProject={(eventProps = {}) =>
                        BlockFeatureAction(
                          SIDEBAR,
                          'new_project',
                          projects?.length,
                          () => this.openAddProjectModal({}, eventProps),
                          () =>
                            this.showPromptModal(
                              translate('project_prompt_headline'),
                              translate(
                                canBuyAddon && domainAddon
                                  ? 'project_limit_addon_offer'
                                  : 'project_prompt_text',
                              ),
                              {
                                ...eventProps,
                                [PROPERTY_NAMES.btn_location]:
                                  PROPERTY_VALUES.nav_bar.new_project,
                                btnLocation:
                                  MIXPANEL_PROPS.PURCHASE_BUTTON_LOCATION.values
                                    .LIMIT_REACHED_MODAL,
                              },
                              true,
                              null,
                              false,
                              canBuyAddon && domainAddon
                                ? allAddonsTypes.ADDON_DOMAIN
                                : null,
                            ),
                        )()
                      }
                      handleEditProject={this.handleEditProject}
                      isLoadingProjects={isLoadingProjects}
                    />
                  )}
                  <Page>
                    {!loadingUser ? (
                      <>
                        {isSignedIn() &&
                          !isConfirmedUser() &&
                          !skipEmailConfirmAlertPaths.some((path) =>
                            window.location.pathname.endsWith(path),
                          ) && (
                            <Mobile>
                              <EmailConfirmAlert
                                ref={this.emailConfirmAlertMobileRef}
                              >
                                <EmailConfirmText>
                                  <Text
                                    lineHeight="20px"
                                    fontFamily={fonts.primary}
                                    boldColor={palette.darkGray}
                                    dangerouslySetInnerHTML={{
                                      __html: translate(
                                        'confirm_email_modal_text',
                                        user.email,
                                      ),
                                    }}
                                  />
                                  <Text
                                    lineHeight="20px"
                                    fontFamily={fonts.primary}
                                  >
                                    {translate('check_spam_note')}
                                  </Text>
                                </EmailConfirmText>
                                {this.renderEmailConfirmButton(user.email, {
                                  marginTop: '10px',
                                })}
                              </EmailConfirmAlert>
                            </Mobile>
                          )}
                        {verificationStatus &&
                          verificationStatus.email &&
                          verificationStatus.status && (
                            <TableNotificationBar
                              key="notificaton-bar"
                              style={{ margin: '0', padding: '0 40px' }}
                            >
                              <TableNotification
                                type="success"
                                content={
                                  <Text
                                    lineHeight="24px"
                                    boldColor={palette.darkGray}
                                    dangerouslySetInnerHTML={{
                                      __html: translate(
                                        'confirm_email_success_message',
                                        verificationStatus.email,
                                      ),
                                    }}
                                  />
                                }
                                onClose={() =>
                                  this.setState({ verificationStatus: null })
                                }
                              />
                            </TableNotificationBar>
                          )}
                        <UberRouter
                          languageCode={languageCode}
                          {...this.props}
                          user={user}
                          injectReducer={injectReducer}
                          injectSagas={injectSagas}
                        />
                        <ErrorModal isOpen={isErrorModalOpen.isOpen} />
                        <AddProjectModal
                          initialState={{
                            ...initialAddProjectData,
                          }}
                          isOpen={isOpenAddProjectModal}
                          onRequestClose={this.closeAddProjectModal}
                          onFinish={this.finishProjectCreation}
                          userProjects={projects || []}
                          closeAddProjectModal={() => {
                            this.setState({ isOpenAddProjectModal: false })
                          }}
                          source="ubs-side-bar"
                          eventProps={addProjectEventProps}
                        />
                        {checkoutModal.isOpen && (
                          <TurnstileProvider
                            WrappedComponent={CheckoutModal}
                            isOpen={checkoutModal.isOpen}
                            onClose={() => {
                              this.stopRecording()
                              this.setState({
                                checkoutModal: { isOpen: false },
                              })
                            }}
                          />
                        )}
                        <ProjectSettingsModal
                          isOpen={projectSettingsModal.isOpen}
                          isLoading={isUpdatingProject}
                          project={projectSettingsModal.project}
                          onRequestClose={(updateSubscription = false) =>
                            this.setState(
                              {
                                projectSettingsModal: {
                                  isOpen: false,
                                },
                              },
                              () => {
                                if (updateSubscription) fetchSubscription()
                              },
                            )
                          }
                          onSave={this.handleSaveProject}
                          onRemoveProject={(onComplete) =>
                            deleteProject(
                              onComplete,
                              projectSettingsModal.project.id,
                            )
                          }
                          next={
                            history.location.pathname + history.location.search
                          }
                        />
                      </>
                    ) : (
                      <Loading />
                    )}
                    <ConfirmationModal
                      isOpen={upgradePopup.isOpen}
                      title={upgradePopup.title}
                      message={upgradePopup.message}
                      hideFooter={!upgradePopup.isUpgraded}
                      renderFooter={() => {
                        const guideText = translate('getting_started_guide')
                        const text = translate(
                          'subscription_upgraded_get_started',
                          guideText,
                        )
                        return (
                          <Text
                            fontSize="12px"
                            lineHeight="26px"
                            fontFamily={fonts.primaryLight}
                          >
                            {reactStringReplace(text, guideText, (match) => {
                              return (
                                <span
                                  role="button"
                                  tabIndex={0}
                                  key="cancel-link"
                                  style={{
                                    color: palette.orange,
                                    cursor: 'pointer',
                                    fontFamily: fonts.primaryBook,
                                    textDecoration: 'underline',
                                  }}
                                  onClick={() =>
                                    openInNewTab(
                                      'https://knowledgebase.neilpatel.com/what-is-ubersuggest-getting-started-guide/',
                                    )
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      openInNewTab(
                                        'https://knowledgebase.neilpatel.com/what-is-ubersuggest-getting-started-guide/',
                                      )
                                    }
                                  }}
                                >
                                  {match}
                                </span>
                              )
                            })}
                          </Text>
                        )
                      }}
                      onClose={() => {
                        this.updateUserInfo((updatedUserData) => {
                          if (
                            upgradePopup.isUpgraded &&
                            !isMobile &&
                            hasAtp !== 'true'
                          ) {
                            Mixpanel.trackAtpCrossSellModalView({
                              planTier: updatedUserData?.subscription?.tier,
                              billingCycle:
                                updatedUserData?.subscription?.planInterval,
                              subscription: updatedUserData?.subscription,
                              source:
                                MIXPANEL_PROPS.SOURCE.values
                                  .PRICING_PAGE_CHECKOUT_MODAL,
                            })
                          }
                        })
                        const hasAtp = sessionStorage.getItem('hatp')
                        if (
                          upgradePopup.isUpgraded &&
                          !isMobile &&
                          hasAtp !== 'true'
                        ) {
                          this.openATPCrossSellModal(
                            false,
                            upgradePopup.next,
                            upgradePopup.utmParams,
                          )
                          this.setState({
                            upgradePopup: { isOpen: false },
                          })
                          return
                        }
                        if (upgradePopup.showAIWPlanModal) {
                          const { tier } = upgradePopup
                          const { next } = upgradePopup
                          if (
                            user?.subscription?.addOns &&
                            !user.subscription.addOns.some((addon) =>
                              isAIWAddon(getAddonTypeFromCode(addon.code)),
                            )
                          ) {
                            setTimeout(
                              () => this.openAIWPlanModal(tier, next),
                              1000,
                            )
                            this.setState({
                              upgradePopup: { isOpen: false },
                            })
                            return
                          }
                        }
                        // Should not clear token in this case
                        // clearToken()
                        window.location = upgradePopup.next
                          ? upgradePopup.next
                          : `/${languageCode}/dashboard${
                              upgradePopup.isUpgraded ? '?upgraded=success' : ''
                            }`
                        this.setState({
                          upgradePopup: { isOpen: false },
                        })
                      }}
                    />
                    {user?.subscription && (
                      <SpecialLifetimeModal
                        isOpen={
                          lifetimeReminderModal.isOpen && !isGrowthbookFeatureOn
                        }
                        tier={lifetimeReminderModal.tier}
                        onDeny={this.hideLifetimeReminderModal}
                        source="ubs-life-time-reminder"
                      />
                    )}
                    {user?.subscription && (
                      <PastDueModal isOpen={pastDueModal.isOpen} />
                    )}
                    <PaymentErrorModal
                      openUpdatePaymentMethodModal={() => {
                        this.setState({
                          isOpenUpdatePaymentMethodModal: true,
                        })
                      }}
                      isOpen={isOpenPaymentErrorModal}
                      onClose={() => {
                        this.setState({
                          isOpenPaymentErrorModal: {
                            isOpen: false,
                          },
                        })
                      }}
                    />
                    {user?.subscription && (
                      <PurchaseAddonModal
                        isOpen={purchaseAddonModal.isOpen}
                        onClose={() => {
                          closePromptModal()
                          this.setState({
                            purchaseAddonModal: { isOpen: false },
                          })
                        }}
                        addonDetail={purchaseAddonModal.addonDetail}
                        onPurchaseAddon={(args) =>
                          this.handlePurchaseAddon({
                            ...args,
                            initialProjectData:
                              purchaseAddonModal.initialProjectData,
                            from: promptModal.from,
                          })
                        }
                        user={user}
                        selectedProject={purchaseAddonModal.selectedProject}
                        noPurchaseClickEvent
                        shouldTriggerAddProjectFlow={
                          promptModal.from !== 'create_project_one_click'
                        }
                      />
                    )}
                    <NavigationChangeModal
                      isOpen={navigationChangeModal?.isOpen}
                      onClose={() => {
                        updateNavigationChangeModal({
                          isOpen: false,
                          openedOnce: true,
                        })
                        updateUserPreferences({
                          nav_change_notified: true,
                        })
                      }}
                    />
                    {allowPromptModal(promptModal) && (
                      <PromptModal
                        isOpen={promptModal.isOpen}
                        title={promptModal.title}
                        message={promptModal.message}
                        forceUpgrade={promptModal.forceUpgrade}
                        eventProperty={promptModal.eventProperty}
                        showLoginLink={promptModal.showLoginLink}
                        addonType={promptModal.addonType}
                        overlayStyle={{ zIndex: 10001 }}
                        addonProjectId={promptModal.addonProjectId}
                        from={promptModal.from}
                        onClickBuyAddon={(addonType, addonProjectId) =>
                          this.showPurchaseAddonModal(
                            addonType,
                            addonProjectId,
                            promptModal.initialProjectData,
                          )
                        }
                        onDeny={() => {
                          if (promptModal.from === 'UNLOGGED_PROJECT') {
                            removeUnloggedUserProject()
                            window.location.reload()
                          }
                          if (
                            promptModal.from ===
                            'add_project_modal_with_leads_data'
                          ) {
                            sendMessage('CLOSE_ADD_PROJECT_MODAL')
                          }
                          closePromptModal()
                          if (promptModal.next) {
                            window.location.href = promptModal.next
                          }
                        }}
                        onUpgrade={() => {
                          const { btnLocation } = promptModal.eventProperty
                          const mixpanelProps = [
                            btnLocation,
                            isPaidUser() || isFreeTrialUsed()
                              ? MIXPANEL_PROPS.BUTTON_CTA.values.UPGRADE
                              : MIXPANEL_PROPS.BUTTON_CTA.values.START_TRIAL,
                          ]

                          checkoutModalHandler({
                            mixpanelProps,
                          })
                          closePromptModal()
                        }}
                        onRegister={() => {
                          pushWithLanguageRoutes(
                            `/${languageCode}/register?next=${
                              history.location.pathname +
                              history.location.search
                            }`,
                          )
                          closePromptModal()
                        }}
                        lang={languageCode}
                        next={
                          history.location.pathname + history.location.search
                        }
                        parentSelector={() =>
                          document.getElementById('prompt-modal-global')
                        }
                        onClose={() => {
                          closePromptModal()
                        }}
                        isEnterpriseUser={promptModal.isEnterpriseUser}
                      />
                    )}
                    <LoginLimitModal
                      testId="login-limit-modal"
                      isOpen={loginLimitModal.isOpen}
                      type={loginLimitModal.type}
                      title={loginLimitModal.title}
                      message={loginLimitModal.message}
                      onClose={() => {
                        const { type } = loginLimitModal
                        updateLoginLimitModal({
                          isOpen: false,
                        })
                        if (type === 'SIGN_OUT_WARNING') {
                          signOut(
                            `/${getLanguageCode()}/login?next=${
                              window.location.href
                            }`,
                          )
                        }
                      }}
                      onRedirect={() => {
                        updateLoginLimitModal({
                          isOpen: false,
                        })
                      }}
                      parentSelector={() =>
                        document.getElementById('prompt-modal-global')
                      }
                    />
                    {!loadingUser && plansLoaded && (
                      <AIWPlanModal
                        isOpen={aiwPlanModal.isOpen}
                        user={user}
                        onAccept={(plan, status = 'success') => {
                          if (status === 'success') this.updateUserInfo()

                          kissmetricsRecordingEvent(
                            KISSMETRICS_TRACK_EVENTS.aiw_oder_bump,
                            {
                              [PROPERTY_NAMES.aiw_addon_status]:
                                PROPERTY_VALUES.aiw_addon_status[status],
                              [PROPERTY_NAMES.aiw_addon_selected]:
                                PROPERTY_VALUES.aiw_addons[plan],
                              [PROPERTY_NAMES.subscription_plan_selected]:
                                PROPERTY_VALUES.plan_tier[aiwPlanModal.tier],
                            },
                          )
                          this.handleCloseAIWPlanModal()
                        }}
                        onDeny={() => {
                          kissmetricsRecordingEvent(
                            KISSMETRICS_TRACK_EVENTS.aiw_oder_bump,
                            {
                              [PROPERTY_NAMES.aiw_addon_status]:
                                PROPERTY_VALUES.aiw_addon_status.abandoned,
                              [PROPERTY_NAMES.subscription_plan_selected]:
                                PROPERTY_VALUES.plan_tier[aiwPlanModal.tier],
                            },
                          )
                          this.handleCloseAIWPlanModal()
                        }}
                      />
                    )}
                    <ATPCrossSellModal
                      isOpen={
                        atpCrossSellModal.isOpen &&
                        !user?.subscription?.bfATPPromoClaimed
                      }
                      onAccept={() => {
                        this.handleCloseATPCrossSellModal(true)
                      }}
                      onDeny={() => {
                        this.handleCloseATPCrossSellModal()
                      }}
                    />
                    <Desktop>
                      {!skipExitIntentModalPaths.some(
                        (path) => window.location.pathname.indexOf(path) > -1,
                      ) &&
                        !upgradePopup.isOpen &&
                        !promptModal.isOpen && (
                          <ExitIntentModal
                            isOpen={exitIntentModal.isOpen}
                            onClose={() => {
                              this.setState({
                                exitIntentModal: {
                                  isOpen: false,
                                  openedOnce: true,
                                },
                              })
                            }}
                            lang={languageCode}
                          />
                        )}
                    </Desktop>
                    {user?.subscription && (
                      <>
                        <UpdatePaymentMethodModal
                          isOpen={isOpenUpdatePaymentMethodModal}
                          subscriptionType={subscriptionType}
                          onSave={(
                            { paymentMethod, threeDSecureToken },
                            callback,
                          ) => {
                            updateUserPaymentMethod(
                              paymentMethod.id,
                              threeDSecureToken,
                            )
                              .then((res) => {
                                callback(null)
                                this.setState({
                                  isOpenUpdatePaymentMethodModal: false,
                                })
                                if (res.status === 204) {
                                  return window.location.reload()
                                }
                              })
                              .catch((err) => {
                                if (err.response) {
                                  const { code } = err.response.data

                                  if (isThreeDSecureError(code)) {
                                    callback(err.response.data.description)
                                    return
                                  }
                                }

                                this.setState({
                                  updatePaymentMethodError:
                                    translate('card_error'),
                                })
                                callback(null)
                              })
                          }}
                          onError={(errorText) =>
                            this.setState({
                              updatePaymentMethodError: errorText,
                            })
                          }
                          onRequestClose={() =>
                            this.setState({
                              isOpenUpdatePaymentMethodModal: false,
                            })
                          }
                        />
                        <ConfirmationModal
                          isOpen={updatePaymentMethodError !== null}
                          title={translate('error')}
                          overlayStyle={{ zIndex: 10003 }}
                          message={updatePaymentMethodError}
                          hideFooter
                          onClose={() => {
                            this.setState({
                              updatePaymentMethodError: null,
                              isOpenUpdatePaymentMethodModal: true,
                            })
                          }}
                        />
                      </>
                    )}
                    <EmailConfirmModal
                      isOpen={emailConfirmModal.isOpen}
                      email={emailConfirmModal.email}
                      isSentEmail={emailConfirmModal.isSentEmail}
                      hideCloseIcon={emailConfirmModal.hideCloseIcon}
                      onSubmit={() =>
                        this.handleResendVerificationEmail(
                          emailConfirmModal.email,
                        )
                      }
                      onClose={this.closeEmailConfirmModal}
                    />
                    <AdblockDetectModal
                      isOpen={isDetectedAdblock && !isClosedAdblockDetectModal}
                      onAccept={() => this.closeAdblockDetectModal(true)}
                      onDeny={() => this.closeAdblockDetectModal(false)}
                    />
                  </Page>
                </Body>
              </>
            )}
          </LayoutWrapper>
        </>
      </AppContext.Provider>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  user: selectCurrentUser(),
  alerts: selectAlerts(),
  siteAuditReportAlert: selectSiteAuditReportReadyAlerts(),
  loadingUser: selectLoadingUser(),
  languageLoaded: selectLanguageLoaded(),
  lifetimeReminderModal: selectLifetimeReminderModal(),
  navigationChangeModal: selectNavigationChangeModall(),
  aiwPlanModal: selectAIWPlanModal(),
  atpCrossSellModal: selectATPCrossSellModal(),
  projects: selectProjects(),
  currentProject: selectCurrentProject(),
  isUpdatingProject: selectIsUpdatingProject(),
  isLoadingProjects: selectIsLoadingProjects(),
  loginLimitModal: selectLoginLimitModal(),
  extraHeaderHeight: selectExtraHeaderHeight(),
  isCheckingAdblock: selectIsCheckingAdblock(),
  isDetectedAdblock: selectIsDetectedAdblock(),
  isClosedAdblockDetectModal: selectIsClosedAdblockDetectModal(),
  promptModal: selectPromptModal(),
})

const mapDispatchToProps = (dispatch) => ({
  updateAlerts: (info) => dispatch(fetchAlerts(info)),
  markAlertsAs: (alertIds, setAs) =>
    dispatch(
      markAlertsAsAction({
        alertIds,
        setAs,
      }),
    ),
  closeSiteAuditReportAlert: () => dispatch(closeSiteAuditReportAlertAction()),
  updateUserInfo: (onComplete) => dispatch(fetchUser(onComplete)),
  updateUserPreferences: (preferences) =>
    dispatch(updateUserPreferencesAction(preferences)),
  loadLanguage: () => dispatch(loadLanguage()),
  updateLifetimeReminderModal: (data) =>
    dispatch(updateLifetimeReminderModal(data)),
  updateNavigationChangeModal: (data) =>
    dispatch(updateNavigationChangeModalAction(data)),
  addProject: (payload, leadsData, onComplete) =>
    dispatch(addProject(payload, leadsData, onComplete)),
  updateAIWPlanModal: (data) => dispatch(updateAIWPlanModal(data)),
  updateATPCrossSellModal: (data) => dispatch(updateATPCrossSellModal(data)),
  changeCurrentProject: (projectId) =>
    dispatch(changeCurrentProject(projectId)),
  updateProject: (id, payload, onComplete) =>
    dispatch(updateProject(id, payload, onComplete)),
  reloadProject: (id, onComplete) => dispatch(reloadProject(id, onComplete)),
  deleteProject: (onComplete, projectId) =>
    dispatch(deleteProjectAction(onComplete, projectId)),
  fetchSubscription: () => dispatch(fetchSubscriptionAction()),
  updateLoginLimitModal: (data) => dispatch(updateLoginLimitModalAction(data)),
  updateExtraHeaderHeight: (height) => dispatch(setExtraHeaderHeight(height)),
  closeAdblockDetectModal: () => dispatch(closeAdblockerModal()),
  updatePromptModal: (data) => dispatch(updatePromptModal(data)),
  closePromptModal: () => dispatch(closePromptModalAction()),
  fetchProjects: () => dispatch(fetchProjects()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withGrowthbookFeature(Layout, [
    growthbookFeatures.NEW_CHECKOUT_PLAN_SELECTION_V2,
    growthbookFeatures.NEW_MONTHLY_PRICE,
    growthbookFeatures.INR_CURRENCY,
  ]),
)
